import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-primary-deep-blue text-white" data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-139">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-140">
          {/* Organization Info */}
          <div data-id="element-141">
            <h3 className="text-xl font-playfair mb-4" data-id="element-142">Farasha Medical Aid</h3>
            <p className="font-inter text-sm mb-4" data-id="element-143">
              Connecting American generosity with Egyptian monastery
              communities, delivering essential medical supplies to clinics
              serving populations often overlooked by conventional healthcare
              systems.
            </p>
            <p className="font-inter text-sm" data-id="element-144">
              501(c)(3) nonprofit organization
              <br data-id="element-145" />
              EIN: XX-XXXXXXX
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-146">
            <h3 className="text-xl font-playfair mb-4" data-id="element-147">Quick Links</h3>
            <ul className="space-y-2 font-inter text-sm" data-id="element-148">
              <li data-id="element-149">
                <Link to="/" className="hover:underline" data-id="element-150">
                  Home
                </Link>
              </li>
              <li data-id="element-151">
                <Link to="/about" className="hover:underline" data-id="element-152">
                  About Us
                </Link>
              </li>
              <li data-id="element-153">
                <Link to="/coptic-people" className="hover:underline" data-id="element-154">
                  The Coptic People
                </Link>
              </li>
              <li data-id="element-155">
                <Link to="/blog" className="hover:underline" data-id="element-156">
                  Blog
                </Link>
              </li>
              <li data-id="element-157">
                <Link to="/contact" className="hover:underline" data-id="element-158">
                  Contact
                </Link>
              </li>
              <li data-id="element-159">
                <Link to="/donate" className="hover:underline" data-id="element-160">
                  Donate
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-161">
            <h3 className="text-xl font-playfair mb-4" data-id="element-162">Legal & Transparency</h3>
            <ul className="space-y-2 font-inter text-sm" data-id="element-163">
              <li data-id="element-164">
                <Link to="/privacy" className="hover:underline" data-id="element-165">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-166">
                <Link to="/terms" className="hover:underline" data-id="element-167">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Newsletter */}
          <div data-id="element-168">
            <h3 className="text-xl font-playfair mb-4" data-id="element-169">Stay Connected</h3>
            <p className="font-inter text-sm mb-4" data-id="element-170">
              <a href="mailto:natasha.farashamed@gmail.com" className="hover:underline" data-id="element-171">
                natasha.farashamed@gmail.com
              </a>
            </p>
            <div className="flex space-x-4 mb-6" data-id="element-172">
              <a href="#" className="text-white hover:text-primary-gold" data-id="element-173">
                <Facebook size={20} data-id="element-174" />
              </a>
              <a href="#" className="text-white hover:text-primary-gold" data-id="element-175">
                <Twitter size={20} data-id="element-176" />
              </a>
              <a href="#" className="text-white hover:text-primary-gold" data-id="element-177">
                <Instagram size={20} data-id="element-178" />
              </a>
              <a href="#" className="text-white hover:text-primary-gold" data-id="element-179">
                <Linkedin size={20} data-id="element-180" />
              </a>
              <a href="mailto:natasha.farashamed@gmail.com" className="text-white hover:text-primary-gold" data-id="element-181">
                <Mail size={20} data-id="element-182" />
              </a>
            </div>
            <h4 className="font-inter font-medium mb-2" data-id="element-183">
              Subscribe to our newsletter
            </h4>
            <form className="flex" data-id="element-184">
              <input type="email" placeholder="Your email" className="px-3 py-2 bg-white text-primary-deep-blue rounded-l-md w-full focus:outline-none" data-id="element-185" />
              <button type="submit" className="bg-primary-gold hover:bg-primary-royal-blue text-white px-4 py-2 rounded-r-md transition-colors" data-id="element-186">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-sm font-inter text-center" data-id="element-187">
          <p data-id="element-188">
            © {new Date().getFullYear()} Farasha Medical Aid. All rights
            reserved.
          </p>
          <p className="mt-2" data-id="element-189">
            Donations are tax-deductible to the extent allowed by law.
          </p>
        </div>
      </div>
    </footer>;
}